import createIcon from '../../createIcon';

/**
 * @component @name MicNone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTQuNUMxMy42NiAxNC41IDE0Ljk5IDEzLjE2IDE0Ljk5IDExLjVMMTUgNS41QzE1IDMuODQgMTMuNjYgMi41IDEyIDIuNUMxMC4zNCAyLjUgOSAzLjg0IDkgNS41VjExLjVDOSAxMy4xNiAxMC4zNCAxNC41IDEyIDE0LjVaTTEwLjggNS40QzEwLjggNC43NCAxMS4zNCA0LjIgMTIgNC4yQzEyLjY2IDQuMiAxMy4yIDQuNzQgMTMuMiA1LjRMMTMuMTkgMTEuNkMxMy4xOSAxMi4yNiAxMi42NiAxMi44IDEyIDEyLjhDMTEuMzQgMTIuOCAxMC44IDEyLjI2IDEwLjggMTEuNlY1LjRaTTE3LjMgMTEuNUMxNy4zIDE0LjUgMTQuNzYgMTYuNiAxMiAxNi42QzkuMjQgMTYuNiA2LjcgMTQuNSA2LjcgMTEuNUg1QzUgMTQuOTEgNy43MiAxNy43MyAxMSAxOC4yMlYyMS41SDEzVjE4LjIyQzE2LjI4IDE3Ljc0IDE5IDE0LjkyIDE5IDExLjVIMTcuM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MicNone = createIcon('MicNone', [
  [
    'path',
    {
      d: 'M12 14.5C13.66 14.5 14.99 13.16 14.99 11.5L15 5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V11.5C9 13.16 10.34 14.5 12 14.5ZM10.8 5.4C10.8 4.74 11.34 4.2 12 4.2C12.66 4.2 13.2 4.74 13.2 5.4L13.19 11.6C13.19 12.26 12.66 12.8 12 12.8C11.34 12.8 10.8 12.26 10.8 11.6V5.4ZM17.3 11.5C17.3 14.5 14.76 16.6 12 16.6C9.24 16.6 6.7 14.5 6.7 11.5H5C5 14.91 7.72 17.73 11 18.22V21.5H13V18.22C16.28 17.74 19 14.92 19 11.5H17.3Z',
      key: '9gbg70',
    },
  ],
]);

export default MicNone;
